export const errorTranslations = {
	'A user with the given email is already registered': {
		en: 'A user with the given email is already registered',
		et: 'Email on juba kasutuses',
	},
};
